import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../components/Common/Actions";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../components/Layout";
import Deletepopup from "../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

const FrpStates = () => {
  const navigate = useNavigate();
  const addNewState = {
    id: "addnewpost",
    onClick: () => navigate("/frp-states/add-new-state"),
    style: { width: "240px" },
    label: "Add New State",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}frp-states/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("frp-states", fetchData, setShowDelete);

  const updateActiveStatus = (data) => {
    setLoader(true)
    axios
      .post(
        `${process.env.REACT_APP_API_URL}frp-states/update/${data?.slug_url}`,
        {
          ...data,
          active: !data?.active,
        },
      )
      .then(() => fetchData());
  };

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      width: 100,
    },
    {
      title: "States",
      dataIndex: "state",
      key: "state",
      width: 550,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          recordActiveStatus={record.active}
          viewLabel={"View Cities"}
          isActive={true}
          isEdit={true}
          isDelete={true}
          onClickDelete={() => {
            setDeleteId(record.slug_url);
            setShowDelete(true);
          }}
          onClickView={() =>
            navigate(`/frp-states/view-cities/${record.slug_url}`)
          }
          onClickActive={() => updateActiveStatus(record)}
          onClickEdit={() =>
            navigate(`/frp-states/edit-state/${record.slug_url}`)
          }
        />
      ),
    },
  ];
  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <Breadcrumbs breadcrumbsList={[{ text: "FRP / States", link: "" }]} />
      }
      addButton={<FilledButton props={addNewState} />}
      titles={<></>}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable medicineList_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default FrpStates;
